import { I03PSYCHROAIR_State } from '@batical/types/src'

const I03PSYCHROAIR: I03PSYCHROAIR_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_pressionAtmospherique: 1013.0,
  in_tempAir: 0.0,
  in_humiditeRelative: 0.0,
  res_masseVolumeAir: 0.0,
  res_viscDyn: 0.0,
  res_viscCin: 0.0,
  res_pressionVapeur: 0.0,
  res_pressionPartielle: 0.0,
  res_humSpec: 0.0,
  res_condThermique: 0.0,
  res_tempRose: 0.0,
  res_volMassique: 0.0,
  res_enthAir: 0.0,
  res_tempSaturation: 0.0,
  mode: 'none',
  calcul_code: 'I03PSYCHROAIR'
}

export default I03PSYCHROAIR
